import { Badge, Space } from 'antd';
import React from 'react';

// 설정값 렌더링 (타입별 포맷팅)
export const renderConfigValue = (key: string, value: any): React.ReactNode => {
  if (typeof value === 'boolean') {
    return (
      <Badge
        status={value ? 'success' : 'default'}
        text={value ? '활성화' : '비활성화'}
      />
    );
  }

  if (typeof value === 'number') {
    return (
      <span style={{ fontFamily: 'monospace' }}>{value}</span>
    );
  }

  if (typeof value === 'string') {
    if (value.startsWith('#')) {
      return (
        <Space>
          <div
            style={{
              width: 16,
              height: 16,
              backgroundColor: value,
              border: '1px solid #d9d9d9',
              borderRadius: 2
            }}
          />
          <span style={{ fontFamily: 'monospace' }}>{value}</span>
        </Space>
      );
    }
    return <span style={{ wordBreak: 'break-all' }}>{value}</span>;
  }

  return JSON.stringify(value);
};

// 배경 타입 옵션
export const backgroundTypeOptions = [
  { value: 'color', label: '색상' },
  { value: 'image', label: '이미지' },
  { value: 'gif', label: 'GIF' },
  { value: 'video', label: '비디오' }
];

// 미디어 파일 필터링 유틸리티
export const filterMediaFilesByType = (mediaFiles: any[], type: string) => {
  return mediaFiles.filter(file => {
    const ext = file.filename.toLowerCase();
    if (type === 'image') {
      return ext.includes('.jpg') || ext.includes('.jpeg') || ext.includes('.png') || ext.includes('.webp');
    } else if (type === 'gif') {
      return ext.includes('.gif');
    } else if (type === 'video') {
      return ext.includes('.mp4') || ext.includes('.mov') || ext.includes('.avi');
    }
    return false;
  });
};

export const getVideoFiles = (mediaFiles: any[]) => {
  return mediaFiles.filter(file => {
    const ext = file.filename.toLowerCase();
    return ext.includes('.mp4') || ext.includes('.mov') || ext.includes('.avi');
  });
};